import React from 'react'
// libs
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { useMutation } from '@apollo/client/react'
import { getFormValues, reduxForm } from 'redux-form'
// types
import { Forms } from 'constants/forms'
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
import { ICompanyDataPrivacySettings } from 'types/graphql'
// components
import { ReduxSwitch } from 'components/FormElements'
// graphql
import { COMPANY_UPDATE_MUTATION } from 'graphql/company/mutations'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
// utils
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

const Form = styled.form`
  height: 100%;
  padding: 20px;
  border-radius: 4px;
  box-shadow:
    0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14),
    0px 1px 8px 0px rgba(0, 0, 0, 0.12);
`

const Label = styled.div`
  margin-bottom: 40px;
`

const DataPrivacyForm: React.FC<InjectedFormProps<ICompanyDataPrivacySettings>> = () => {
  const user = useCurrentUser()

  const formValues = useSelector((state: any) => getFormValues(Forms.BUSINESS_ACTIVITY_FORM)(state))

  const [updatePrivacy] = useMutation(COMPANY_UPDATE_MUTATION)

  const handleSwitchChange = (_event: any, next: boolean, name: string) => {
    updatePrivacy({
      variables: {
        id: user.company.id,
        company: {
          dataPrivacySettings: { ...formValues, [name]: next }
        }
      }
    }).catch((error) => console.log('[DataPrivacyForm.handleSwitchChange]: ', parseGraphQLErrorMessages(error)))
  }

  return (
    <Form>
      <Label>Make this data visible to everyone</Label>
      <ReduxSwitch
        reverse
        preventInitialChange
        label={'Positions'}
        name={'publicPositions'}
        listenOnChange={handleSwitchChange}
      />
      <ReduxSwitch
        reverse
        label={'Users'}
        name={'publicUsers'}
        preventInitialChange
        listenOnChange={handleSwitchChange}
      />
      <ReduxSwitch
        reverse
        preventInitialChange
        label={'Locations'}
        name={'publicLocations'}
        listenOnChange={handleSwitchChange}
      />
      <ReduxSwitch
        reverse
        preventInitialChange
        label={'Business Units'}
        name={'publicBusinessUnits'}
        listenOnChange={handleSwitchChange}
      />
      <ReduxSwitch
        reverse
        preventInitialChange
        label={'Response-Type Options'}
        name={'publicResponseTypeOptions'}
        listenOnChange={handleSwitchChange}
      />
    </Form>
  )
}

export default reduxForm<ICompanyDataPrivacySettings>({
  form: Forms.BUSINESS_ACTIVITY_FORM,
  enableReinitialize: true
})(DataPrivacyForm)
